<template>
  <div>
    <header>
      <div class="left">
        <h2>Approval Queue</h2>
        <p>
          {{`${pendingApprovals.length} Approval${pendingApprovals.length !== 1 ? 's' : ''} Pending`}}
        </p>
      </div>

      <div class="right">
      </div>
    </header>

    <hr />

    <div v-if="loadingNewData" class="loader">Loading...</div>
    <div v-else>
      <div v-if="pendingApprovals.length < 1" class="loader">Your Pending Benefit Approvals Will Display Here</div>
      <transition-group name="list" tag="div">
        <PendingBenefitApproval
          v-for="(approvalRequest, i) in pendingApprovals"
          :key="approvalRequest.id"
          :benefitApproval="approvalRequest"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import PendingBenefitApproval from "@/components/PendingBenefitApproval";
import {mapGetters} from "vuex";
export default {
  name: 'PendingBenifitApprovals',
  components: {PendingBenefitApproval},

  data() {
    return {
      loadingNewData: false
    };
  },
  computed: {
    ...mapGetters(['pendingApprovals']),
    app_user() {
      return this.$store.getters.app_user;
    },
    org() {
      return this.$store.getters.org;
    },
  },
  methods: {
    getPendingApprovals() {
      this.loadingNewData = true;
      this.$store.dispatch('getApprovals')
        .catch((e) => console.error(e))
        .finally(() => (this.loadingNewData = false))
    }
  },
  created() {
    this.getPendingApprovals();
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';
.loader {
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  color: $sidebar-color;
  opacity: 0.5;
}

.list-enter-active,
.list-leave-active {
  transition: none;
}

</style>
